<div [class.pr-small-x]="includePaddings" [class.pr-small-t]="includePaddings">
  <button
    [attr.id]="'service-item-' + uuid"
    [attr.aria-controls]="'service-item-content-' + uuid"
    [attr.aria-expanded]="expandOpen"
    class="fill flex no-outline"
    (click)="expandOpen = !expandOpen"
    [disabled]="disabled"
  >
    <div class="btn-content fill flex flex--space-between">
      <span class="flex flex--top ms-xsmall-r fill">
        <fcom-icon
          [name]="getIconForService()"
          class="icon-medium ms-xsmall-r nordic-blue-900-text text-icon-primary flex--shrink0"
        />
        <div class="flex-1">
          <span class="medium-type font-heading-5 flex align-left flex--wrap font-title-small">
            <span class="flex flex-1 flex--wrap">
              <span class="ms-xsmall-r" data-testid="product-item-title">{{
                buttonTranslationKey | finLocalization
              }}</span>
              @if (showUnpaidTag && service()?.unpaidQuantity) {
                <fcom-tag [theme]="TagTheme.WARNING" class="nowrap" data-testid="unpaid-item-tag">
                  <fcom-icon [name]="SvgLibraryIcon.SHOPPING_CART" class="icon-small ms-xxsmall-r" />
                  <span class="nowrap dn-laptop-down">
                    {{
                      service().unpaidQuantity === 1
                        ? ('MMB.includedProducts.unpaidAncillaries.tagTitleSingular'
                          | finLocalization: { quantity: service().unpaidQuantity })
                        : ('MMB.includedProducts.unpaidAncillaries.tagTitlePlural'
                          | finLocalization: { quantity: service().unpaidQuantity })
                    }}
                  </span>
                  <span class="dn-laptop-up">{{ service().unpaidQuantity }}</span>
                </fcom-tag>
              } @else if (enableQuotaTag() && displayedQuotaCount()) {
                <fcom-tag [theme]="TagTheme.DEFAULT" data-testid="low-quota-tag">
                  <span class="nowrap">
                    {{ 'ancillaries.quota.onlyQuotaLeft' | finPluralLocalization: displayedQuotaCount() : 'quota' }}
                  </span>
                </fcom-tag>
              }
            </span>
            @if (additionalTitle && additionalTitle.length > 0) {
              <span class="flex--nogrow" data-testid="product-item-additional-title">{{ additionalTitle }}</span>
            }
          </span>
          @if (!expandOpen || service()?.upsell) {
            <fin-included-product-item-summary
              class="fill align-left block"
              [passengers]="passengers"
              [bound]="bound()"
              [service]="service()"
              [isShortHaulFlight]="isShortHaulFlight"
              [showPendingServicesInTitles]="showPendingServicesInTitles"
            />
          }
        </div>
      </span>
      <fcom-icon
        class="flex-1 flex--nogrow rotate icon-medium nordic-blue-900-text text-icon-primary"
        [class.rotate-active]="expandOpen"
        [name]="SvgLibraryIcon.CHEVRON_DOWN"
      />
    </div>
  </button>
</div>

<fcom-expand
  class="block"
  [open]="expandOpen"
  [ariaId]="'service-item-content-' + uuid"
  [ariaLabelledBy]="'service-item-' + uuid"
>
  <div
    class="flex flex--column"
    [ngClass]="{ 'ms-xsmall-t': !includePaddings, 'mr-small-t pr-small-x': includePaddings }"
  >
    <div *ngIf="displaySeatReassignMessage" class="white-bg surface-primary rounded-large border mr-medium-b">
      <div class="pr-xsmall">
        <div class="ms-small-b">
          <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.INFO" />
          <span class="font-body-1 medium-type font-label-medium">
            {{ 'MMB.purchase.success.seats.reassignNote.title' | finLocalization }}
          </span>
        </div>
        <div class="font-body-1 mr-medium-l font-body-medium">
          {{ 'MMB.purchase.success.seats.reassignNote.message' | finLocalization }}
        </div>
      </div>
    </div>
    <ng-content />
  </div>
</fcom-expand>
